import { FormGroup } from '@angular/forms';

export interface IOtp {
  formGroup: FormGroup;
  verify(): void;
}
